import styled from 'styled-components';
import {Row} from '../../../ui-toolkit';
import DetailCategory from './DetailCategory';
import {colSetup} from '../../../ui-toolkit/grid/grid-features/col/ColContainer';

export const formDetailUISetup = () => `
    display: list-item;
    font-size: var(--text-size-medium);
    font-weight: 700;
    margin-left:6px;
    
    ::marker {
        color: var(--container-text-color-disabled-100);
    }
`;

export const colPaddingReset = () => `
    padding-right: 0px;
    padding-left: 0px;
    margin-right: 0px;
    margin-left: 0px;
`;

const DetailBlock = styled(Row)`
    ${({isRoot}) =>
        isRoot &&
        ` --row-spacer: 0.75rem;
    `}

    ${({isRoot}) =>
        !isRoot &&
        `
        ${colPaddingReset()}
        display: block;
        ${DetailCategory.Wrapper}{
            ${colSetup({width: `100% !important`})};
            ${colPaddingReset()}
            padding-top: 0px;
        }
       
    `}
`;

export default DetailBlock;
